import { EditorState, ContentBlock, BlockMapBuilder, Modifier, RichUtils, Entity, genKey } from 'draft-js';
import { List, Map } from 'immutable';

const Styles = {
  active: (draft, style) => draft.getCurrentInlineStyle().has(style),
  toggle: (draft, style) => RichUtils.toggleInlineStyle(draft, style),
};

const Blocks = {
  active: (draft, block) => RichUtils.getCurrentBlockType(draft) === block,
  toggle: (draft, block) => RichUtils.toggleBlockType(draft, block),
  insert: (draft, data) => {
    const content = draft.getCurrentContent();
    const selection = draft.getSelection();

    const removalState = Modifier.removeRange(content, selection, 'backward');
    const splitState = Modifier.splitBlock(removalState, removalState.getSelectionAfter());
    const target = splitState.getSelectionAfter();

    const block = Modifier.replaceWithFragment(
      Modifier.setBlockType(splitState, target, 'atomic'),
      target,
      BlockMapBuilder.createFromArray([
        new ContentBlock({ key: genKey(), type: 'atomic', text: '', characterList: List(), data: Map(data) }),
        new ContentBlock({ key: genKey(), type: 'unstyled', text: '', characterList: List() }),
      ])
    );

    return EditorState.push(
      draft,
      block.merge({
        selectionBefore: selection,
        selectionAfter: block.getSelectionAfter().set('hasFocus', true),
      }),
      'insert-fragment'
    );
  },
};

const Entities = {
  all: (block, callback, state, type) => {
    block.findEntityRanges(character => {
      const entity = character.getEntity();
      return entity !== null && state.getEntity(entity).getType() === type;
    }, callback);
  },
  selected: (draft, type = false) => {
    const content = draft.getCurrentContent();

    const selection = draft.getSelection();
    const selectedBlockKey = selection.getAnchorKey();

    let selectedEntity = null;
    const entities = [];

    content.getBlockForKey(selectedBlockKey).findEntityRanges(
      character => {
        const entityKey = character.getEntity();

        if (entityKey !== null) {
          const entity = content.getEntity(entityKey);

          if (!type || entity.getType() === type) {
            selectedEntity = { entityKey, blockKey: selectedBlockKey, entity };
            return true;
          }

          return false;
        }
      },
      (start, end) => {
        if (
          (selection.getStartOffset() <= end && selection.getEndOffset() >= start) ||
          (selection.getEndOffset() >= start && selection.getStartOffset() <= end)
        ) {
          entities.push({ ...selectedEntity, start, end });
        }
      }
    );

    return entities;
  },
  active: (draft, type = false) => Entities.selected(draft, type).length > 0,
  toggle: (draft, type = null, mutability = null, data = null) => {
    if (Entities.active(draft, type)) {
      // need to make this smarter, currently just nullifies all entities in selection range
      return RichUtils.toggleLink(draft, draft.getSelection(), null);
    }
    return RichUtils.toggleLink(draft, draft.getSelection(), Entity.create(type, mutability, data));
  },
};

const DraftUtils = {
  Styles,
  Blocks,
  Entities,
};

export { DraftUtils };
